import { format } from "date-fns";

export function formatDate(date: Date | string, dateFormat: string, utc: boolean = false) {
  if (!(date instanceof Date))
    date = new Date(date);

  if (date && utc)
    date = toUtc(date);

  return format(date, dateFormat);
}

function toUtc(date: Date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
};

export function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d.valueOf());
}

const timeFormatter = new Intl.RelativeTimeFormat("us", { numeric: "auto", style: "short" });
const msPerSecond = 1000;
const msPerMinute = 60 * msPerSecond;
const msPerHour = msPerMinute * 60;
const msPerDay = msPerHour * 24;

export function formatRelativeTime(date: Date | string) {
  if (!(date instanceof Date))
    date = new Date(date);

  const elapsed = Date.now() - date.getTime();

  if (elapsed < msPerMinute) return timeFormatter.format(-Math.floor(elapsed / msPerSecond), 'seconds');
  if (elapsed < msPerHour) return timeFormatter.format(-Math.floor(elapsed / msPerMinute), 'minutes');
  if (elapsed < msPerDay) return timeFormatter.format(-Math.floor(elapsed / msPerHour), 'hours');

  return timeFormatter.format(-Math.floor(elapsed / msPerDay), 'days');
}